export function useStoryblokVersion() {
  const config = useStoryblokConfig();
  const {isPreview} = useStoryblokPreview();

  if (isPreview.value) {
    return 'draft';
  }

  return import.meta.dev
    ? config.version?.development
    : config.version?.production;
}
